import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from 'react-intl';

import { get } from 'utils/lodash';

import { USER_STATUS_DISABLED } from 'settings/constants/self-unlock';
import { DEFAULT_CONTACT_NO } from 'settings/constants/common';

import { BasicButton } from 'components/common/buttons';
import { Grid, Typography } from '@material-ui/core';

const SelfUnlockFooter = ({ handleSubmit, verifiedDetail, isResetPasswordForm, handleBack, isPasswordMatch }) => {
  const { formatMessage } = useIntl();

  const userStatus = get(verifiedDetail, 'userStatus', '');
  const contactNo = get(verifiedDetail, 'serviceInfoBean.mainNote6', DEFAULT_CONTACT_NO);

  const isDisabled = userStatus === USER_STATUS_DISABLED;

  return (
    <Grid container>
      <Grid container justify="flex-end">
        {(isDisabled || isResetPasswordForm) && (
          <BasicButton
            title={formatMessage({ id: 'selfUnlock.modal.backButton' })}
            className="transparent-bb db ph4 back-button-spacing"
            onClick={handleBack}
          />
        )}

        <BasicButton
          title={formatMessage({ id: 'selfUnlock.modal.footerButton' })}
          className="db ph4"
          onClick={handleSubmit}
          disabled={!isPasswordMatch && isResetPasswordForm}
        />
      </Grid>

      {isDisabled && (
        <Grid container justify="center" className="red mt4">
          <Typography>
            <FormattedMessage id="selfUnlock.modal.unlock.disabledWording" values={{ contactNo }} />
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

SelfUnlockFooter.defaultProps = {
  isPasswordMatch: false,
};

SelfUnlockFooter.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  verifiedDetail: PropTypes.object.isRequired,
  isResetPasswordForm: PropTypes.bool.isRequired,
  handleBack: PropTypes.func.isRequired,
  isPasswordMatch: PropTypes.bool,
};

export default SelfUnlockFooter;
